/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateScheduleOfValuesPayloadDto
 */
export interface UpdateScheduleOfValuesPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateScheduleOfValuesPayloadDto
     */
    fireMultiplier?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScheduleOfValuesPayloadDto
     */
    biRate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScheduleOfValuesPayloadDto
     */
    pdRate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScheduleOfValuesPayloadDto
     */
    sovId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScheduleOfValuesPayloadDto
     */
    submissionId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScheduleOfValuesPayloadDto
     */
    severity?: UpdateScheduleOfValuesPayloadDtoSeverityEnum;
}


/**
 * @export
 */
export const UpdateScheduleOfValuesPayloadDtoSeverityEnum = {
    Low: 'Low',
    Average: 'Average',
    High: 'High'
} as const;
export type UpdateScheduleOfValuesPayloadDtoSeverityEnum = typeof UpdateScheduleOfValuesPayloadDtoSeverityEnum[keyof typeof UpdateScheduleOfValuesPayloadDtoSeverityEnum];


/**
 * Check if a given object implements the UpdateScheduleOfValuesPayloadDto interface.
 */
export function instanceOfUpdateScheduleOfValuesPayloadDto(value: object): value is UpdateScheduleOfValuesPayloadDto {
    if (!('sovId' in value) || value['sovId'] === undefined) return false;
    return true;
}

export function UpdateScheduleOfValuesPayloadDtoFromJSON(json: any): UpdateScheduleOfValuesPayloadDto {
    return UpdateScheduleOfValuesPayloadDtoFromJSONTyped(json, false);
}

export function UpdateScheduleOfValuesPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScheduleOfValuesPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fireMultiplier': json['fireMultiplier'] == null ? undefined : json['fireMultiplier'],
        'biRate': json['biRate'] == null ? undefined : json['biRate'],
        'pdRate': json['pdRate'] == null ? undefined : json['pdRate'],
        'sovId': json['sovId'],
        'submissionId': json['submissionId'] == null ? undefined : json['submissionId'],
        'severity': json['severity'] == null ? undefined : json['severity'],
    };
}

export function UpdateScheduleOfValuesPayloadDtoToJSON(json: any): UpdateScheduleOfValuesPayloadDto {
    return UpdateScheduleOfValuesPayloadDtoToJSONTyped(json, false);
}

export function UpdateScheduleOfValuesPayloadDtoToJSONTyped(value?: UpdateScheduleOfValuesPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fireMultiplier': value['fireMultiplier'],
        'biRate': value['biRate'],
        'pdRate': value['pdRate'],
        'sovId': value['sovId'],
        'submissionId': value['submissionId'],
        'severity': value['severity'],
    };
}

